package com.milta.core.localization.translations.bg

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Маршрут",
    navEcoDriving = "Еко шофиране",
    navCommunity = "Общност",
    navRewards = "Награди",
    navHome = "Начало",
    navRoutes = "Маршрути",
    navTeam = "Екип",
    navProfile = "Профил",
    navDashboard = "Dashboard",
)
